import { get, ref, type Database } from 'firebase/database';
import { getAuth } from 'firebase/auth';

/** Throws the standard Swedish error when nobody is logged in; returns the UID. */
export const requireUser = (action: string): string => {
    const user = getAuth().currentUser;
    if (!user) {
        throw new Error(`Du måste vara inloggad för att ${action}`);
    }
    return user.uid;
};

/**
 * Admin gate for API-layer mutations. Accepts `admin` or `superadmin`, the
 * same answer as `useIsAdmin` in the UI and the admin idiom in
 * database.rules.json, so a superadmin without the admin flag is never
 * shown a button the API then refuses (parking-tenants plan D6).
 */
export const requireAdmin = async (db: Database, action: string): Promise<string> => {
    const uid = requireUser(action);
    const snapshot = await get(ref(db, `users/userList/${uid}`));
    const profile = snapshot.exists() ? (snapshot.val() as Record<string, unknown>) : undefined;
    if (profile?.admin !== true && profile?.superadmin !== true) {
        throw new Error(`Du måste vara administratör för att ${action}`);
    }
    return uid;
};

/** Superadmin gate for instance-wide operations (data migrations). */
export const requireSuperadmin = async (db: Database, action: string): Promise<string> => {
    const uid = requireUser(action);
    const snapshot = await get(ref(db, `users/userList/${uid}`));
    const profile = snapshot.exists() ? (snapshot.val() as Record<string, unknown>) : undefined;
    if (profile?.superadmin !== true) {
        throw new Error(`Du måste vara superadministratör för att ${action}`);
    }
    return uid;
};
